import { render, staticRenderFns } from "./PhotosGallery.vue?vue&type=template&id=7e43dd6d&"
import script from "./PhotosGallery.vue?vue&type=script&lang=js&"
export * from "./PhotosGallery.vue?vue&type=script&lang=js&"
import style0 from "./PhotosGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports